import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'isBlocking' && prop !== 'isResolved',
})<{ isBlocking?: boolean; isResolved?: boolean }>(
  ({ theme, isBlocking, isResolved }) => ({
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
    border: '1px solid',
    ...(isResolved && {
      backgroundColor: '#F0F9F0',
      borderColor: theme.palette.success.main,
      '& .MuiTypography-root': {
        color: theme.palette.success.dark,
      },
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: `0 4px 8px ${theme.palette.success.main}20`,
        borderColor: theme.palette.success.dark,
      },
    }),
    ...(isBlocking &&
      !isResolved && {
        backgroundColor: '#FFF5F5',
        borderColor: theme.palette.error.main,
        borderWidth: 2,
        '& .MuiTypography-root': {
          color: theme.palette.error.dark,
        },
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: `0 4px 8px ${theme.palette.error.main}20`,
          borderColor: theme.palette.error.dark,
        },
      }),
    ...(!isBlocking &&
      !isResolved && {
        backgroundColor: '#FFFBEB',
        borderColor: theme.palette.warning.main,
        '& .MuiTypography-root': {
          color: theme.palette.warning.dark,
        },
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: `0 4px 8px ${theme.palette.warning.main}20`,
          borderColor: theme.palette.warning.dark,
        },
      }),
  }),
);

export const IconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ theme, color }) => ({
  color,
  marginRight: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
}));

export const BlockingBadge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: '4px 8px',
  backgroundColor: '#FFE5E5',
  color: '#CC0000',
  borderBottomLeftRadius: theme.shape.borderRadius,
  fontSize: '0.75rem',
  fontWeight: 600,
  letterSpacing: '0.2px',
}));

export const ActionButton = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  top: '50%',
  transform: 'translateY(-50%)',
}));
